import { preview } from '@/components/form/preview'
import { BulkViewData } from '../../hooks/useBulkViewData/types'
import { useTexts } from './hooks/useTexts'

type Props = {
  bulkData: BulkViewData
}

export function Company(props: Props) {
  const {
    bulkData: { company },
  } = props
  const texts = useTexts()

  return (
    <preview.Field label={texts.company.label}>
      {company === 'mixed' ? (
        <preview.MixValue />
      ) : company.length === 0 ? (
        <preview.NullValue />
      ) : (
        company
      )}
    </preview.Field>
  )
}
